import { render, staticRenderFns } from "./my_address.vue?vue&type=template&id=232b1a0c&scoped=true"
import script from "./my_address.vue?vue&type=script&lang=js"
export * from "./my_address.vue?vue&type=script&lang=js"
import style0 from "./my_address.vue?vue&type=style&index=0&id=232b1a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b1a0c",
  null
  
)

export default component.exports